import React from 'react';
import { Users, Clock, DollarSign } from 'lucide-react';
interface KpiCardsProps {
  onCardClick?: (cardId: 'created' | 'converted' | 'funded') => void;
  created: number;
  converted: number;
  funded: number;
  pullThrough: number;
  avgCycleDays: number;
}
export function KpiCards({
  onCardClick,
  created,
  converted,
  funded,
  pullThrough,
  avgCycleDays
}: KpiCardsProps) {
  const convertedPct = created > 0 ? (converted / created * 100).toFixed(1) : '0.0';
  return <div className="grid grid-cols-1 md:grid-cols-4 gap-5 mb-8" data-id="element-169">
      {/* Leads Created */}
      <div onClick={() => onCardClick?.('created')} className="bg-white rounded-xl shadow-sm border border-gray-200/80 overflow-hidden relative flex flex-col p-6 hover:shadow-md transition-all group cursor-pointer active:scale-[0.98]" data-id="element-170">
        <div className="absolute left-0 top-0 bottom-0 w-1.5 bg-[#3d3d3d]" data-id="element-171"></div>
        <div className="flex justify-between items-start mb-3" data-id="element-172">
          <span className="text-sm text-gray-500 font-semibold uppercase tracking-wider" data-id="element-173">
            Leads Created
          </span>
          <div className="bg-[#3d3d3d]/10 p-2 rounded-lg text-[#3d3d3d] group-hover:scale-110 transition-transform" data-id="element-174">
            <Users size={18} data-id="element-175" />
          </div>
        </div>
        <div className="text-4xl font-bold text-[#3d3d3d] mb-3 tracking-tight" data-id="element-176">
          {created.toLocaleString()}
        </div>
        <div data-id="element-177">
          <span className="inline-block px-2.5 py-1 bg-[#c9a84c]/10 text-[#c9a84c] border border-[#c9a84c]/20 text-xs font-bold rounded-md" data-id="element-178">
            COHORT
          </span>
        </div>
      </div>

      {/* Converted to Opp */}
      <div onClick={() => onCardClick?.('converted')} className="bg-white rounded-xl shadow-sm border border-gray-200/80 overflow-hidden relative flex flex-col p-6 hover:shadow-md transition-all group cursor-pointer active:scale-[0.98]" data-id="element-179">
        <div className="absolute left-0 top-0 bottom-0 w-1.5 bg-[#5a7fa5]" data-id="element-180"></div>
        <div className="flex justify-between items-start mb-3" data-id="element-181">
          <span className="text-sm text-gray-500 font-semibold uppercase tracking-wider" data-id="element-182">
            Converted to Opp
          </span>
          <div className="bg-[#5a7fa5]/10 p-2 rounded-lg text-[#5a7fa5] group-hover:scale-110 transition-transform" data-id="element-183">
            <Clock size={18} data-id="element-184" />
          </div>
        </div>
        <div className="text-4xl font-bold text-[#3d3d3d] mb-3 tracking-tight" data-id="element-185">
          {converted.toLocaleString()}
        </div>
        <div className="text-sm font-semibold text-[#5a7fa5] flex items-center gap-1.5 bg-[#5a7fa5]/5 w-fit px-2 py-0.5 rounded" data-id="element-186">
          <span className="text-lg leading-none" data-id="element-187">↗</span> {convertedPct}% of
          created
        </div>
      </div>

      {/* Funded Loans */}
      <div onClick={() => onCardClick?.('funded')} className="bg-white rounded-xl shadow-sm border border-gray-200/80 overflow-hidden relative flex flex-col p-6 hover:shadow-md transition-all group cursor-pointer active:scale-[0.98]" data-id="element-188">
        <div className="absolute left-0 top-0 bottom-0 w-1.5 bg-[#c9a84c]" data-id="element-189"></div>
        <div className="flex justify-between items-start mb-3" data-id="element-190">
          <span className="text-sm text-gray-500 font-semibold uppercase tracking-wider" data-id="element-191">
            Funded Loans
          </span>
          <div className="bg-[#c9a84c]/10 p-2 rounded-lg text-[#c9a84c] group-hover:scale-110 transition-transform" data-id="element-192">
            <DollarSign size={18} data-id="element-193" />
          </div>
        </div>
        <div className="text-4xl font-bold text-[#3d3d3d] mb-3 tracking-tight" data-id="element-194">
          {funded.toLocaleString()}
        </div>
        <div className="text-sm font-semibold text-[#5a7fa5] flex items-center gap-1.5 bg-[#5a7fa5]/5 w-fit px-2 py-0.5 rounded" data-id="element-195">
          <span className="text-lg leading-none" data-id="element-196">↗</span> {pullThrough}%
          pull-through
        </div>
      </div>

      {/* Avg. Cycle Time */}
      <div className="bg-white rounded-xl shadow-sm border border-gray-200/80 overflow-hidden relative flex flex-col p-6 hover:shadow-md transition-shadow group" data-id="element-197">
        <div className="absolute left-0 top-0 bottom-0 w-1.5 bg-gray-400" data-id="element-198"></div>
        <div className="flex justify-between items-start mb-3" data-id="element-199">
          <span className="text-sm text-gray-500 font-semibold uppercase tracking-wider" data-id="element-200">
            Avg. Cycle Time
          </span>
          <div className="bg-gray-100 p-2 rounded-lg text-gray-500 group-hover:scale-110 transition-transform" data-id="element-201">
            <Clock size={18} data-id="element-202" />
          </div>
        </div>
        <div className="text-4xl font-bold text-[#3d3d3d] mb-3 flex items-baseline gap-1.5 tracking-tight" data-id="element-203">
          {avgCycleDays}{' '}
          <span className="text-base font-medium text-gray-400" data-id="element-204">days</span>
        </div>
        <div className="text-sm font-medium text-gray-500 bg-gray-50 w-fit px-2 py-0.5 rounded" data-id="element-205">
          Created → Funded
        </div>
      </div>
    </div>;
}